export default {
    //组件
    componentType:'tours',
    //跟团序号
    productId:'',
    //线路ID
    journeyId:'',
    //当天ID
    dayId:'',
}


// WEBPACK FOOTER //
// ./src/vuex/toursVip/state.js